import { useCallback } from 'react';
import { PrimaryButton, Layout } from "../components/index";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router"

const PreOrderComplete = () => {
    const dispatch = useDispatch()

    const goBackToTop = useCallback(() => {
        dispatch(push('/brand/rzeus'))
    }, [dispatch])

    return (
        <Layout>
            <section style={{textAlign:'center'}}>
                <div className='spacer-100' />
                <div className='spacer-100' />
                <p>ご予約ありがとうございます。</p>
                <p>ご注文を承りました。</p>
                <p>商品が発売されましたら順次</p>
                <p>ご連絡いたしますので</p>
                <p>今しばらくお待ちください。</p>
                <div className='spacer-50' />
                <PrimaryButton label="RZEUSページに戻る" operation={goBackToTop} />
                <div className='spacer-100' />
                <div className='spacer-100' />
            </section>
        </Layout>
    );
};

export default PreOrderComplete;